import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-copy-button',
    imports: [CommonModule],
    templateUrl: './copy-button.component.html',
    styleUrl: './copy-button.component.scss'
})
export class CopyButtonComponent{

  @Input() data: any = ''; 
  @Input() commentKey: string = 'comment'; 
  constructor() {}

  copyText(text: string, log: any) {
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      // Change icon
      log.copied = true;
    });
  }
}
